import { render, staticRenderFns } from "./DiscountPercentageTag.vue?vue&type=template&id=82b9818a&"
import script from "./DiscountPercentageTag.vue?vue&type=script&lang=ts&"
export * from "./DiscountPercentageTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports